/**
 * Статусы заявки. Единственное место, где они объявлены: api, watcher, фронт и база
 * (CHECK в миграциях сверяется тестом) берут список отсюда.
 */
export const APPLICATION_STATUSES = [
  // основной путь
  'created',
  'access_verified',
  'awaiting_payment',
  'searching',
  'slot_found',
  'booking',
  'booked',
  'completed',
  // ветки, у каждой обязательна причина
  'needs_client',
  'needs_operator',
  'paused',
  'stopped',
] as const

export type ApplicationStatus = (typeof APPLICATION_STATUSES)[number]

/** Смысловая группа для цвета; сами цвета в `@getslot/ui-tokens` (`statusTones`). */
export type StatusTone = 'search' | 'found' | 'booked' | 'client' | 'operator' | 'pause' | 'muted'

export type StatusKind = 'main' | 'branch' | 'terminal'

export interface StatusMeta {
  readonly label: string
  readonly kind: StatusKind
  readonly tone: StatusTone
}

export const STATUS_META: Readonly<Record<ApplicationStatus, StatusMeta>> = {
  created: { label: 'Создана', kind: 'main', tone: 'muted' },
  access_verified: { label: 'Данные проверены', kind: 'main', tone: 'muted' },
  awaiting_payment: { label: 'Ожидаем оплату', kind: 'main', tone: 'client' },
  searching: { label: 'Ищем дату', kind: 'main', tone: 'search' },
  slot_found: { label: 'Дата найдена', kind: 'main', tone: 'found' },
  booking: { label: 'Подтверждаем запись', kind: 'main', tone: 'found' },
  booked: { label: 'Записан', kind: 'main', tone: 'booked' },
  completed: { label: 'Завершено', kind: 'terminal', tone: 'muted' },
  needs_client: { label: 'Нужен ваш ответ', kind: 'branch', tone: 'client' },
  needs_operator: { label: 'Нужен оператор', kind: 'branch', tone: 'operator' },
  paused: { label: 'Приостановлен', kind: 'branch', tone: 'pause' },
  stopped: { label: 'Остановлен', kind: 'terminal', tone: 'muted' },
}

export function isApplicationStatus(value: unknown): value is ApplicationStatus {
  return typeof value === 'string' && (APPLICATION_STATUSES as readonly string[]).includes(value)
}

export function isTerminal(status: ApplicationStatus): boolean {
  return STATUS_META[status].kind === 'terminal'
}

export function isBranch(status: ApplicationStatus): boolean {
  return STATUS_META[status].kind === 'branch'
}

/** Только в этом статусе watcher опрашивает календарь для заявки. */
export function isPollable(status: ApplicationStatus): boolean {
  return status === 'searching'
}
